const pushNotifications = {
  'push-notifications-breadcrumbs': 'Серверные уведомления',
  'push-notifications-filter-title': 'Фильтр серверных уведомлений',
  'push-notifications-clone-failed': 'Ошибка при клонировании серверного уведомления',
  'push-notifications-clone-successfully': 'Серверное уведомление успешно клонировано',
  'push-notifications-send-test': 'Отправить тестовое уведомление',
  'push-notifications-device-token': 'Токен устройства',
  'push-notifications-send-test-success': 'Тестовое серверное уведомление успешно отправлено',
  'push-notifications-send-test-error': 'Произошла ошибка при отправке тестового уведомления',
  'push-notifications-unable-delete': 'Невозможно удалить серверное уведомление, так как существует связанное расписание',
  'push-notifications-unable-update': 'Невозможно обновить серверное уведомление, так как существует связанное расписание',
  'push-notifications-test-publish-note': 'Внимание: Отправка уведомления на устройство доступна раз в 10 секунд',
};

export default pushNotifications;
